import React from 'react';
import { Typography, Button, Checkbox } from '@mui/material';
import { refactorPriceRange } from '../../utils/_helpers';
import { BasePopup } from './BasePopup.jsx';

// prettier-ignore
export const Level1EmptyDialog = ({ open, handleCloseLevel1Dialog, handleAddLevel1ForEmpty, level1Empty, title, context }) => {

	const [isChecked, setIsChecked] = React.useState(() =>
		level1Empty.map((i) => true)
	);

	const isCheckboxChecked = (index, checked) => {
		setIsChecked((isChecked) => {
			return isChecked.map((c, i) => {
				if (i === index) return checked;
				return c;
			});
		});
	};

	const checkAll = (checked) => {
		const newArray = new Array(isChecked.length);
		for(let i=0; i<newArray.length; i++) {
			newArray[i] = checked;
		}
		setIsChecked(newArray);
	}

	const handleAddLevel1DetailsAndClose = (checkedState, level1Details) => (event) => {
		handleCloseLevel1Dialog()
		handleAddLevel1ForEmpty(checkedState, level1Details)
	}

	return <BasePopup
		title={title}
		style={{height: '50vh'}}
		content={<>
			<Typography variant='body1' sx={{ padding: '4px 24px' , color: 'rgb(102, 110, 114)', fontWeight: '400' }} align='justify'>
				Are you sure that you want to link the new {title.toLowerCase()} to the release strategy?
			</Typography>
			<div className='show-scrollbar' style={{height: '100%'}}>
				<div className='flex-column-container-flex-start'>
					<div className='flex-row-container'>
						<Checkbox
							checked={isChecked.every(c => c)}
							onChange={(e) => checkAll(e.target.checked)}
							color="success"
						/>
						<Typography variant='body2'><i>Select All</i></Typography>
					</div>
				</div>
				{level1Empty && level1Empty.map((obj, idx) => {
					return (<div className='flex-column-container-flex-start ' key={idx}>
						<div className='flex-row-container'>
							<Checkbox
								key={idx}
								checked={isChecked[idx]}
								onChange={(e) => isCheckboxChecked(idx, e.target.checked)}
								color="success"
							/>
							<Typography variant='body1' sx={{ color: 'rgb(246,136,53)', fontWeight: 'bold' }}>{`Level ${idx}, ${refactorPriceRange(obj.PriceRange)}`}</Typography>
						</div>
						<Typography variant='caption' sx={{ marginLeft: '0.8rem', color: 'rgb(102, 110, 114)' }}>{`Release code: ${obj.RelCode} - Release group: ${obj.RelGroup}`}</Typography>
					</div>)
				})}
			</div>
		</>}
		button={
			<Button
				onClick={handleAddLevel1DetailsAndClose(isChecked, level1Empty)}
				variant='contained'
				color='primary'
				sx={{ marginBottom: '2vh',}}
			>
				Link to {title.toLowerCase()}
			</Button>
		}
		handleCloseDialog={handleCloseLevel1Dialog}
	/>;
}
